import axios from 'plugins/axios'

export const state = {
  shop: null,
  meta: {
    useRootContainer: true,
    isMobile: false,
    isEditor: false
  }
}

export const getters = {
  get: (state) => {
    if (!state.shop) return {}
    return state.shop
  },
  getMetaIsMobile: (state) => {
    return state.meta.isMobile
  },
  getMetaIsEditor: (state) => {
    return state.meta.isEditor
  },
  getUseRootContainer: (state) => {
    return state.meta.useRootContainer
  }
}

export const mutations = {
  set (state, shop) {
    state.shop = shop
  },
  setMetaIsMobile (state, isMobile) {
    state.meta.isMobile = isMobile
  },
  setMetaIsEditor (state, isEditor) {
    state.meta.isEditor = isEditor
  },
  setUseRootContainer (state, useRootContainer) {
    state.meta.useRootContainer = useRootContainer
  }
}

export const actions = {
  async request ({state, commit}) {
    if (state.shop) return

    let {data} = await axios.get('/shop')
    commit('set', data.data)
  }
}



// WEBPACK FOOTER //
// ./client/store/shop.js